import React from "react";
import { useUpdateEffect } from "react-use";
import { useStoreActions, useStoreState } from "app/state/store/hooks";

interface Props {
  loadData?: boolean;
  returnData?: boolean;
}

export function useCMSCollections(props: Props) {
  const currentLanguage = useStoreState(
    (state) => state.selectedLanguage.value
  );
  const cmsData = useStoreState((state) => state.cms.formattedCollections);
  const setCMSData = useStoreActions(
    (actions) => actions.cms.formattedCollections.setPagesData
  );

  // Collections state
  const aboutPageCMSData = useStoreState(
    (state) => state.cms.collections.aboutPage.data
  );
  const feedbackPageCMSData = useStoreState(
    (state) => state.cms.collections.feedbackPage.data
  );
  const resultsPageCMSData = useStoreState(
    (state) => state.cms.collections.resultsPage.data
  );
  const statementsPageCMSData = useStoreState(
    (state) => state.cms.collections.statementsPage.data
  );

  // Collections actions
  const aboutPageCMSAction = useStoreActions(
    (actions) => actions.cms.collections.aboutPage.fetch
  );
  const feedbackPageCMSAction = useStoreActions(
    (actions) => actions.cms.collections.feedbackPage.fetch
  );
  const resultsPageCMSAction = useStoreActions(
    (actions) => actions.cms.collections.resultsPage.fetch
  );
  const statementsPageCMSAction = useStoreActions(
    (actions) => actions.cms.collections.statementsPage.fetch
  );

  function formatCMSData() {
    const items = [
      {
        key: "about",
        data: aboutPageCMSData ?? {},
      },
      {
        key: "feedback",
        data: feedbackPageCMSData ?? {},
      },
      {
        key: "results",
        data: resultsPageCMSData ?? {},
      },
      {
        key: "statements",
        data: statementsPageCMSData ?? {},
      },
    ];
    const formattedData: any = {
      about: [],
      feedback: [],
      results: [],
      statements: [],
    };
    items.forEach((item) => {
      // @ts-ignore
      item.data.entries?.forEach((entry: any) => {
        switch (currentLanguage) {
          case "fi":
            formattedData[item.key].push({
              title: entry.title_fi,
              content: entry.content_fi,
              faqItems: entry.faq_items_fi,
            });
            break;
          case "se":
            formattedData[item.key].push({
              title: entry.title_se,
              content: entry.content_se,
              faqItems: entry.faq_items_se,
            });
            break;
          case "en":
          default:
            formattedData[item.key].push({
              title: entry.title,
              content: entry.content,
              faqItems: entry.faq_items,
            });
            break;
        }
      });
    });
    setCMSData(formattedData);
  }

  React.useEffect(() => {
    if (props.loadData) {
      aboutPageCMSAction({
        isCMSfetch: true,
      });
      feedbackPageCMSAction({
        isCMSfetch: true,
      });
      resultsPageCMSAction({
        isCMSfetch: true,
      });
      statementsPageCMSAction({
        isCMSfetch: true,
      });
    }
  }, []);

  useUpdateEffect(() => {
    if (props.loadData) {
      formatCMSData();
    }
  }, [
    currentLanguage,
    aboutPageCMSData,
    resultsPageCMSData,
    feedbackPageCMSData,
    statementsPageCMSData,
  ]);

  if (props.returnData) {
    return cmsData;
  }

  return null;
}
